import { BigButton } from "./BigButton";

export function PauseOverlay({ open, onResume, onRepeat, onRestart, onReturn }) {
  if (!open) return null;
  return (
    <div className="wmleye-pause-overlay" data-testid="pause-overlay" role="dialog" aria-modal>
      <div className="wmleye-pause-overlay__panel">
        <BigButton onClick={onResume} data-testid="pause-resume">Resume</BigButton>
        <BigButton variant="ghost" onClick={onRepeat} data-testid="pause-repeat">
          Repeat mission
        </BigButton>
        <BigButton variant="ghost" onClick={onRestart} data-testid="pause-restart">
          Restart level
        </BigButton>
        <BigButton variant="coral" onClick={onReturn} data-testid="pause-return">
          Return to level map
        </BigButton>
      </div>
    </div>
  );
}
